module.exports = __webpack_public_path__ + "assets/images/chef_04_40b2779484700902062a45d28cb3efec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/trophies/chef_04.png
// module id = 186
// module chunks = 0